module.exports = __webpack_public_path__ + "images/category_lp/brand/point3_130999f1355aa25a26b06f6516c29ac0.png";